import L from 'leaflet'
import Control from './control'
import { VChip, VBtn, VIcon } from 'vuetify/lib'
import { mdiClose } from '@mdi/js'
export default Control.extend({
  options: {
    position: 'bottomcenter'
  },
  onAdd: function () {
    this.options.vue.map.customControls[this.id] = this
    const defaultColor = this.options.defaultColor

    this._container = L.DomUtil.create('div')

    L.DomEvent.disableClickPropagation(this._container)
    L.DomEvent.on(this._container, 'mouseover', this._toggleRuler, this)
    L.DomEvent.on(this._container, 'mouseout', this._toggleRuler, this)

    this._chip = new VChip({
      propsData: {
        label: true,
        small: true,
        color: defaultColor
      }
    })

    this._chip.$vuetify = this.options.vue.$vuetify
    this._chip.$mount()
    this._chip.$el.classList.add('elevation-2')

    this._btn = new VBtn({
      propsData: {
        color: defaultColor,
        fab: true,
        small: true,
        width: 28,
        height: 28
      },
      computed: {
        classes () {
          return {
            'ml-2': true,
            'elevation-2': true,
            'v-btn': true,
            'v-btn--absolute': this.absolute,
            'v-btn--block': this.block,
            'v-btn--bottom': this.bottom,
            'v-btn--disabled': this.disabled,
            'v-btn--is-elevated': this.isElevated,
            'v-btn--fab': this.fab,
            'v-btn--fixed': this.fixed,
            'v-btn--has-bg': this.hasBg,
            'v-btn--icon': this.icon,
            'v-btn--left': this.left,
            'v-btn--loading': this.loading,
            'v-btn--outlined': this.outlined,
            'v-btn--plain': this.plain,
            'v-btn--right': this.right,
            'v-btn--round': this.isRound,
            'v-btn--rounded': this.rounded,
            'v-btn--router': this.to,
            'v-btn--text': this.text,
            'v-btn--tile': this.tile,
            'v-btn--top': this.top,
            ...this.themeClasses,
            ...this.groupClasses,
            ...this.elevationClasses,
            ...this.sizeableClasses,
          }
        }
      }
    })

    this._btn.$slots.default = [this._btn.$createElement(VIcon, mdiClose)]
    this._btn.$vuetify = this.options.vue.$vuetify

    this._btn.$on('click', this._btnClick.bind(this))
    this._btn.$mount()

    this._container.appendChild(this._chip.$el)
    this._container.appendChild(this._btn.$el)
    return this._container
  },
  _toggleRuler: function (event) {
    const segment = this.getSegment()
    if (segment && segment.segmentHover) {
      segment.segmentHover({ type: event.type, target: segment })
    }
  },
  _btnClick: function () {
    const segment = this.getSegment()
    if (segment && segment.remove) {
      segment.remove()
    }

    this.options.vue.map._container.focus()
  },
  getSegment: function () {
    const segmentId = this.id.replace('control-for-', '')
    return this._map.getLayerById(segmentId)
  },
  onRemove: function () {
    L.DomEvent.off(this._container, 'mouseover', this._toggleRuler, this)
    L.DomEvent.off(this._container, 'mouseout', this._toggleRuler, this)

    this._chip.$destroy()
    if (this._chip.$el && this._chip.$el.parentNode) {
      this._chip.$el.parentNode.removeChild(this._chip.$el)
    }

    this._btn.$off('click', this._btnClick)
    this._btn.$destroy()
    if (this._btn.$el && this._btn.$el.parentNode) {
      this._btn.$el.parentNode.removeChild(this._btn.$el)
    }
  },
  updateText: function (value) {
    if (this._chip) {
      const span = document.createElement('span')
      span.innerHTML = `<strong>${value}</strong>`
      span.classList.add('v-chip__content')
      if (this._chip.$el) {
        while (this._chip.$el.firstChild) {
          this._chip.$el.removeChild(this._chip.$el.lastChild);
        }
      }
      this._chip.$el.appendChild(span)
      this._chip.$forceUpdate()
    }
  },
  updateColor: function (color) {
    if (this._btn) {
      this._btn.color = color
    }

    if (this._chip) {
      this._chip.color = color
    }
  }
})